import { render, staticRenderFns } from "./e-guide-item.vue?vue&type=template&id=24fde2c8&scoped=true&lang=pug"
import script from "./e-guide-item.vue?vue&type=script&lang=js"
export * from "./e-guide-item.vue?vue&type=script&lang=js"
import style0 from "./e-guide-item.vue?vue&type=style&index=0&id=24fde2c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fde2c8",
  null
  
)

export default component.exports